import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const Pagination = ({ itemsPerPage, totalItems, paginate, currentPage }) => {
    const [maxPageNumbers, setMaxPageNumbers] = useState(10); // Default set to 10

    // Update the state on window resize
    useEffect(() => {
        const handleResize = () => {
            setMaxPageNumbers(window.innerWidth <= 650 ? 5 : 10);
        };

        // Add resize event listener
        window.addEventListener('resize', handleResize);

        // Set initial value based on current window width
        handleResize();

        // Cleanup listener on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const totalPageCount = Math.ceil(totalItems / itemsPerPage);
    const currentGroupStartPage = Math.floor((currentPage - 1) / maxPageNumbers) * maxPageNumbers + 1;

    // Generate page number array
    const pageNumbers = [];
    for (let i = currentGroupStartPage; i < currentGroupStartPage + maxPageNumbers && i <= totalPageCount; i++) {
        pageNumbers.push(i);
    }

    return (
        <div>
            <ul className='pagination'>
                {/* First page button */}
                {currentPage !== 1 && (
                    <li className='button'>
                        <button
                            onClick={() => paginate(1)}
                            className='page-link'>
                            &laquo;&laquo;
                        </button>
                    </li>
                )}
                {/* Previous group button, if not the first group */}
                {currentGroupStartPage !== 1 && (
                    <li className='button'>
                        <button
                            onClick={() => paginate(currentGroupStartPage - maxPageNumbers)}
                            className='page-link'>
                            &laquo;
                        </button>
                    </li>
                )}
                {/* Previous page button */}
                {currentPage > 1 && (
                    <li className='button'>
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            className='page-link'>
                           &lsaquo;
                        </button>
                    </li>
                )}
                {/* Page numbers */}
                {pageNumbers.map(number => (
                    <li key={number} className={`button ${currentPage === number ? 'active' : ''}`}>
                        <button
                            onClick={() => paginate(number)}
                            className={`page-link ${currentPage === number ? 'active' : ''}`}>
                            {number}
                        </button>
                    </li>
                ))}
                {/* Next page button */}
                {currentPage < totalPageCount && (
                    <li className='button'>
                        <button
                            onClick={() => paginate(currentPage + 1)}
                            className='page-link'>
                            &rsaquo;
                        </button>
                    </li>
                )}
                {/* Next group button */}
                {(totalPageCount === 0 || currentGroupStartPage + maxPageNumbers - 1 < totalPageCount) && (
                    <li className='button'>
                        <button
                            onClick={() => paginate(currentGroupStartPage + maxPageNumbers)}
                            className='page-link'>
                            &raquo;
                        </button>
                    </li>
                )}
                {/* Last page button */}
                {currentPage !== totalPageCount && (
                    <li className='button'>
                        <button
                            onClick={() => paginate(totalPageCount)}
                            className='page-link'>
                            &raquo;&raquo;
                        </button>
                    </li>
                )}
            </ul>
        </div>
    );
};

Pagination.propTypes = {
    itemsPerPage: PropTypes.number.isRequired,
    totalItems: PropTypes.number.isRequired,
    paginate: PropTypes.func.isRequired,
    currentPage: PropTypes.number.isRequired
};

export default Pagination;
